function initCustomSelect(customSelect) {
  // Guard against double-initializing the same select (e.g. if the
  // observer fires more than once for the same node)
  if (customSelect.dataset.customSelectInit) return;
  customSelect.dataset.customSelectInit = 'true';

  var selElmnt = customSelect.querySelector('select');
  var ll = selElmnt.length;

  var selectedOption = selElmnt.options[selElmnt.selectedIndex].innerHTML;

  var selectedDiv = document.createElement("DIV");
  selectedDiv.setAttribute("class", "select-selected");
  var selectedSpan = document.createElement("SPAN");
  selectedSpan.textContent = selectedOption;
  selectedDiv.appendChild(selectedSpan);
  customSelect.appendChild(selectedDiv);

  var optionsDiv = document.createElement("DIV");
  optionsDiv.setAttribute("class", "select-items select-hide");

  for (var j = 0; j < ll; j++) {
    var optionDiv = document.createElement("DIV");
    var optionText = selElmnt.options[j].innerHTML;
    var span = document.createElement("SPAN");
    span.textContent = optionText;
    optionDiv.appendChild(span);

    optionDiv.addEventListener("click", function (e) {
      var optionsDiv = this.parentNode;                       // .select-items
      var customSelect = optionsDiv.parentNode;                // .custom-select
      var s = customSelect.querySelector("select");
      var selectedDiv = customSelect.querySelector(".select-selected");
      var h = selectedDiv.querySelector("span");

      for (var i = 0; i < s.length; i++) {
        if (s.options[i].innerHTML == this.textContent) {
          s.selectedIndex = i;
          h.textContent = this.textContent;
          var sameAsSelected = optionsDiv.getElementsByClassName("same-as-selected");
          for (var k = 0; k < sameAsSelected.length; k++) {
            sameAsSelected[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }

      // Fire a native change event so anything listening to the underlying
      // <select> (Alpine's x-model, cart totals, etc.) picks up the update
      s.dispatchEvent(new Event('change', { bubbles: true }));

      // Close the dropdown directly instead of simulating a click on
      // .select-selected — more reliable than relying on event bubbling
      // through markup we don't fully control the structure of.
      optionsDiv.classList.add('select-hide');
      selectedDiv.classList.remove('select-arrow-active');
    });
    optionsDiv.appendChild(optionDiv);
  }

  customSelect.appendChild(optionsDiv);

  selectedDiv.addEventListener("click", function(e) {
    e.stopPropagation();
    closeAllSelect(this);

    var isOpening = this.nextSibling.classList.contains('select-hide');
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");

    if (isOpening) {
      window.dispatchEvent(new CustomEvent('dropdown:opened', { detail: { source: 'custom-select' } }));
    }
  });
}

function initAllCustomSelects(root) {
  (root || document).querySelectorAll('.custom-select').forEach(initCustomSelect);
}

function closeAllSelect(elmnt) {
  var x = document.getElementsByClassName("select-items");
  var y = document.getElementsByClassName("select-selected");
  for (var i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      continue;
    }
    y[i].classList.remove("select-arrow-active");
    x[i].classList.add("select-hide");
  }
}

document.addEventListener("click", closeAllSelect);

window.addEventListener('dropdown:opened', function (e) {
  if (e.detail && e.detail.source === 'custom-select') return;
  closeAllSelect();
});

// Initial page load
initAllCustomSelects();

// Catch anything added later — quick buy modals, section re-renders, etc.
var customSelectObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return; // only element nodes
      if (node.matches && node.matches('.custom-select')) {
        initCustomSelect(node);
      }
      if (node.querySelectorAll) {
        node.querySelectorAll('.custom-select').forEach(initCustomSelect);
      }
    });
  });
});

customSelectObserver.observe(document.body, { childList: true, subtree: true });